module.exports = __webpack_public_path__ + "media/images/cart/credit-card-10a6272385a778f3c284e445cff60e70.png";